import { useState, useEffect } from "react";
import { Star, X } from "lucide-react";
import { webSiteReviewsService } from "../../services/webReviewServices.js";
import { AuthService } from "../../services/authService";

const ModalAssessment = ({ isOpen, onClose }) => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(null);
  const [comment, setComment] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      const token =
        sessionStorage.getItem("token") || localStorage.getItem("token");
      if (token) {
        const authState = await AuthService.isAuthenticated();
        setIsAuthenticated(authState);
      }
    };

    if (isOpen) {
      checkAuth();
    }
  }, [isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log("=== Iniciando envio de avaliação ===");
    // console.log("Dados do formulário:", { rating, comment });

    try {
      if (!isAuthenticated) {
        throw new Error("Usuário não autenticado");
      }

      // console.log("Enviando avaliação para o serviço...");
      await webSiteReviewsService.createReview(rating, comment);
      // console.log("Avaliação enviada com sucesso!");

      setRating(0);
      setComment("");
      onClose();
    } catch (error) {
      console.error("=== Erro detalhado no handleSubmit ===");
      console.error("Tipo do erro:", error.name);
      console.error("Mensagem do erro:", error.message);
      console.error("Erro completo:", error);

      let errorMessage = "Erro ao enviar avaliação.";

      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      alert(errorMessage);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg p-6 w-full max-w-md relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
          aria-label="Fechar modal"
        >
          <X size={24} />
        </button>

        <h2 className="text-2xl font-bold mb-4 text-gray-700 ">
          Avalie nosso site
        </h2>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Sua avaliação
            </label>
            <div className="flex gap-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  type="button"
                  onClick={() => setRating(star)}
                  onMouseEnter={() => setHover(star)}
                  onMouseLeave={() => setHover(null)}
                  className="focus:outline-none"
                >
                  <Star
                    size={28}
                    className={`transition-colors ${
                      star <= (hover || rating)
                        ? "fill-yellow-400 stroke-yellow-400"
                        : "stroke-gray-300"
                    }`}
                  />
                </button>
              ))}
            </div>
          </div>

          <div className="mb-6">
            <label
              htmlFor="comment"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Comentário
            </label>
            <textarea
              id="comment"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              rows="4"
              className="w-full px-3 py-2 border border-gray-700 rounded-md focus:outline-none focus:border-transparent focus:ring-2 focus:ring-green-500"
              placeholder="O que você achou do nosso site?"
            />
          </div>

          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-green-300 transition-colors flex items-center gap-2"
            >
              <X size={18} />
              Cancelar
            </button>
            <button
              type="submit"
              disabled={!rating || !comment}
              className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 transition-colors flex items-center gap-2"
            >
              <Star size={18} />
              Enviar Avaliação
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModalAssessment;
